export const ADD_SESSION = 'ADD_SESSION'
export const AUTH_CHANGE_STATUS = 'CHANGE_AUTH_STATUS' 
export const AUTH_UPDATE_USER = 'UPDATE_USER'